<template>
    <div v-if="settings" class="mt-4 mb-4">
        <div class="row">
            <div class="col">
                <h2 class="text-center">Treatments Settings</h2>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <!-- time -->
                <div class="form-group row justify-content-center mb-2">
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-left">
                        Time (in days):
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12">
                        <input class="form-control" type="number" min="1" step="1"
                               :class="{ 'is-invalid': $v.settings.addToolSettings.time.$error }"
                               v-model.number="$v.settings.addToolSettings.time.$model">

                        <span class="invalid-feedback" v-if="!$v.settings.addToolSettings.time.required">Time is required</span>
                        <span class="invalid-feedback" v-if="!$v.settings.addToolSettings.time.minValue">
                            Time must be more than {{$v.settings.addToolSettings.time.$params.minValue.min}}
                        </span>
                    </div>
                </div>

                <!-- minimumVotesPercentage -->
                <div class="form-group row justify-content-center mb-2">
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-left">
                        Min votes (in percent):
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12">
                        <input class="form-control" type="number" min="0" max="100" step="1"
                               :class="{ 'is-invalid': $v.settings.addToolSettings.minimumVotesPercentage.$error }"
                               v-model.number="$v.settings.addToolSettings.minimumVotesPercentage.$model">

                        <span class="invalid-feedback" v-if="!$v.settings.addToolSettings.minimumVotesPercentage.required">
                            Min votes is required
                        </span>
                        <span class="invalid-feedback" v-if="!$v.settings.addToolSettings.minimumVotesPercentage.minValue">
                            Min votes must be equal or more than {{$v.settings.addToolSettings.minimumVotesPercentage.$params.minValue.min}}
                        </span>
                        <span class="invalid-feedback" v-if="!$v.settings.addToolSettings.minimumVotesPercentage.maxValue">
                            Min votes must be equal or less than {{$v.settings.addToolSettings.minimumVotesPercentage.$params.maxValue.max}}
                        </span>
                    </div>
                </div>

                <!-- minimumAgreeVotesPercentage -->
                <div class="form-group row justify-content-center mb-2">
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-left">
                        Min agree votes (in percent):
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12">
                        <input class="form-control" type="number" min="0" max="100" step="1"
                               :class="{ 'is-invalid': $v.settings.addToolSettings.minimumAgreeVotesPercentage.$error }"
                               v-model.number="$v.settings.addToolSettings.minimumAgreeVotesPercentage.$model">

                        <span class="invalid-feedback" v-if="!$v.settings.addToolSettings.minimumAgreeVotesPercentage.required">
                            Min agree votes is required
                        </span>
                        <span class="invalid-feedback" v-if="!$v.settings.addToolSettings.minimumAgreeVotesPercentage.minValue">
                            Min agree votes must be equal or more than {{$v.settings.addToolSettings.minimumAgreeVotesPercentage.$params.minValue.min}}
                        </span>
                        <span class="invalid-feedback" v-if="!$v.settings.addToolSettings.minimumAgreeVotesPercentage.maxValue">
                            Min agree votes must be equal or less than {{$v.settings.addToolSettings.minimumAgreeVotesPercentage.$params.maxValue.max}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <h2 class="text-center">Attributes Settings</h2>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <!-- time -->
                <div class="form-group row justify-content-center mb-2">
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-left">
                        Time (in days):
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 ">
                        <input class="form-control" type="number" min="1" step="1"
                               :class="{ 'is-invalid': $v.settings.addQuestionSettings.time.$error }"
                               v-model.number="$v.settings.addQuestionSettings.time.$model">

                        <span class="invalid-feedback" v-if="!$v.settings.addQuestionSettings.time.required">Time is required</span>
                        <span class="invalid-feedback" v-if="!$v.settings.addQuestionSettings.time.minValue">
                            Time must be more than {{$v.settings.addQuestionSettings.time.$params.minValue.min}}
                        </span>
                    </div>
                </div>

                <!-- minimumVotesPercentage -->
                <div class="form-group row justify-content-center mb-2">
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-left">
                        Min votes (in percent):
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12">
                        <input class="form-control" type="number" min="1" max="100" step="1"
                               :class="{ 'is-invalid': $v.settings.addQuestionSettings.minimumVotesPercentage.$error }"
                               v-model.number="$v.settings.addQuestionSettings.minimumVotesPercentage.$model">

                        <span class="invalid-feedback" v-if="!$v.settings.addQuestionSettings.minimumVotesPercentage.required">
                            Min votes is required
                        </span>
                        <span class="invalid-feedback" v-if="!$v.settings.addQuestionSettings.minimumVotesPercentage.minValue">
                            Min votes must be more than {{$v.settings.addQuestionSettings.minimumVotesPercentage.$params.minValue.min}}
                        </span>
                        <span class="invalid-feedback" v-if="!$v.settings.addQuestionSettings.minimumVotesPercentage.maxValue">
                            Min votes must be less than {{$v.settings.addQuestionSettings.minimumVotesPercentage.$params.maxValue.max}}
                        </span>
                    </div>
                </div>

                <!-- minimumAgreeVotesPercentage -->
                <div class="form-group row justify-content-center">
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-left">
                        Min agree votes (in percent):
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12">
                        <input class="form-control" type="number" min="1" max="100" step="1"
                               :class="{ 'is-invalid': $v.settings.addQuestionSettings.minimumAgreeVotesPercentage.$error }"
                               v-model.number="$v.settings.addQuestionSettings.minimumAgreeVotesPercentage.$model">

                        <span class="invalid-feedback" v-if="!$v.settings.addQuestionSettings.minimumAgreeVotesPercentage.required">
                            Min agree votes is required
                        </span>
                        <span class="invalid-feedback" v-if="!$v.settings.addQuestionSettings.minimumAgreeVotesPercentage.minValue">
                            Min agree votes must be more than {{$v.settings.addQuestionSettings.minimumAgreeVotesPercentage.$params.minValue.min}}
                        </span>
                        <span class="invalid-feedback" v-if="!$v.settings.addQuestionSettings.minimumAgreeVotesPercentage.maxValue">
                            Min agree votes must be less than {{$v.settings.addQuestionSettings.minimumAgreeVotesPercentage.$params.maxValue.max}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col mt-3">
                <app-submit-button :btnClass="'d-block mx-auto'" :caption="'Submit'"
                                   :submitAction="submitSettings"/>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";
    import {Settings} from "@/entities/admin/Settings";
    import {HttpHandler} from "@/http/HttpHandler";
    import {maxValue, minValue, required} from "vuelidate/lib/validators";
    import AppSubmitButton from "@/components/AppSubmitButton.vue";
    import store from "@/store/index";

    @Component({
        components: {
            AppSubmitButton,
        }
    })
    export default class SystemSettings extends Vue{
        private settings: Settings | null = null;

        validations() {
            return {
                settings: {
                    addToolSettings: {
                        time: {
                            required,
                            minValue: minValue(1),
                        },
                        minimumVotesPercentage: {
                            required,
                            minValue: minValue(0),
                            maxValue: maxValue(100),
                        },
                        minimumAgreeVotesPercentage: {
                            required,
                            minValue: minValue(0),
                            maxValue: maxValue(100),
                        },
                    },
                    addQuestionSettings: {
                        time: {
                            required,
                            minValue: minValue(1),
                        },
                        minimumVotesPercentage: {
                            required,
                            minValue: minValue(1),
                            maxValue: maxValue(100),
                        },
                        minimumAgreeVotesPercentage: {
                            required,
                            minValue: minValue(1),
                            maxValue: maxValue(100),
                        },
                    },
                }
            };
        }

        async submitSettings() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                throw new Error('Validation error!');
            }

            if (this.settings == null) return;

            const httpHandler = new HttpHandler(store);
            await httpHandler.postSettings(this.settings);
        }

        async created() {
            const httpHandler = new HttpHandler(store);
            this.settings = await httpHandler.getSettings();
        }
    }
</script>

<style scoped lang="scss">
    input[type="number"] {
        appearance: textfield;
    }
</style>
